import { AvatarProps } from '@chakra-ui/react';

import { IdentityType } from '@blockpulse3/graphql/hooks';

import { CompanyIdentityAvatar } from './CompanyIdentityAvatar';
import { UserIdentityAvatar } from './UserIdentityAvatar';

type Props = {
  identity?: {
    type?: IdentityType;
    profilePicture?: string;
  };
  type?: IdentityType;
} & AvatarProps;

/**
 * IdentityAvatar.
 * Avatar switch with the two types of Identity.
 *
 * @param {Props}
 * @returns {JSX.Element}
 */
export function IdentityAvatar({
  identity,
  type = IdentityType.COMPANY,
  ...props
}: Props): JSX.Element {
  const src = identity?.profilePicture || props.src;
  const identityType = identity?.type || type;

  return identityType === IdentityType.INDIVIDUAL ? (
    <UserIdentityAvatar src={src} {...props} />
  ) : (
    <CompanyIdentityAvatar src={src} {...props} />
  );
}

export type IdentityAvatarProps = Props;
